import styled from 'styled-components';

import { Table } from '@thinknet-gmbh/platform-common-ui';

export const StyledRowTable = styled(Table)`
  .ant-table-thead {
    background: ${({ theme }) => theme.colors.tone.lightGrey};
  }
  .ant-table-thead > tr > th {
    padding: 9px 12px;
  }
  .ant-table-content .ant-table-tbody {
    .ant-table-row td > div {
      padding: 5px 12px;
    }
  }
  .ant-table-footer {
    background: none;
    padding: 9px 12px 0 12px;
    .ant-btn {
      padding: 0;
    }
  }
`;

export const AvatarWrapper = styled.div`
  .ant-avatar-group .ant-avatar:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary.blue};
  }
`;
